module.exports = __webpack_public_path__ + "img/img-zhilian-s7-tuya.238cf58e.jpg";